<template>
    <canvas id="oMindSetCompanyChart" width="100%" height="100%"></canvas>
    <div class="top-0 absolute h-full w-full flex items-center justify-center" v-if="!hasData">
      {{ $t('mngDashboardComponent.notEnoughDataToDisplay') }}
    </div>
  </template>
<script>
import { tooltipTeamPlotHelper } from '@/helpers/graphPlotHelper';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-date-fns';

export default {
  name: 'OMindSetChartComponent',
  data() {
    return {
      hasData: false,
      mindSetChart: null,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    // Clean up chart instance if it exists
    if (this.mindSetChart) {
      this.mindSetChart.destroy();
    }
  },

  methods: {
    handleResize() {
      if (this.mindSetChart) {
        this.mindSetChart.resize();
      }
    },
    OMindSetCompanyCharts(OMindSetCompanyData) {
      const ctx = document.getElementById('oMindSetCompanyChart');
      if (!ctx) return;
      ctx.parentNode.style.width = '100%';
      ctx.parentNode.style.height = '100%';
      if (this.mindSetChart) {
        // Destroy the existing chart
        this.mindSetChart.destroy();
      }
      const datasets = OMindSetCompanyData?.data?.datasets?.filter(
        (dataset) => dataset !== null && typeof dataset !== 'undefined',
      ) ?? [];
      this.hasData = !!datasets.find((s) => s.data.find((z) => z));
      if (this.hasData === false) return;
      // eslint-disable-next-line no-param-reassign
      OMindSetCompanyData.options.scales.x.ticks = {
        maxRotation: 0,
        callback(index) {
          const arr = OMindSetCompanyData.data.labels[index].split(' ');
          const combinedArray = [];
          for (let i = 0; i < arr.length; i += 2) {
            if (arr[i + 1]) {
              combinedArray.push(`${arr[i]} ${arr[i + 1]}`);
            } else {
              combinedArray.push(arr[i]);
            }
          }
          return combinedArray;
        },

      };
      this.mindSetChart = new Chart(ctx, {
        type: OMindSetCompanyData?.type,
        data: OMindSetCompanyData?.data,
        options: {
          ...OMindSetCompanyData?.options,
          plugins: {
            tooltip: {
              callbacks: {
                label: (ctx1) => tooltipTeamPlotHelper(ctx1),
              },
            },
          },
        },
      });
    },
  },
};
</script>
